// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__GfcYa","form":"styles_form__zOEo2"};